import script from "./ColorWheelQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorWheelQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./style.scss?vue&type=style&index=0&id=7f5d7990&lang=scss&scoped=true"
import "./ColorWheelQuestion.vue?vue&type=style&index=1&id=7f5d7990&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f5d7990"]])

export default __exports__